import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Discount } from '../../models/discount.model';
import { DiscountCode } from '../../models/discount-code.model';

@Component({
    selector: 'app-discounts-checkbox-selector',
    templateUrl: './discounts-checkbox-selector.component.html',
    styleUrls: ['./discounts-checkbox-selector.component.scss']
})
export class DiscountsCheckboxSelectorComponent implements OnInit {

    @Input() discounts            : Discount[];
    @Input() selectedDiscountCodes: DiscountCode[];

    @Output() selectedDiscountCodesChange = new EventEmitter<DiscountCode[]>();

    public labels: any = {
        directDiscountsSelectorLabel: 'Seleccione los descuentos directos',
        emptyDiscountsError         : 'No hay descuentos directos para la edición del campus seleccionada'
    }

    public selectedDiscounts: { discount: Discount, checked: boolean }[];

    ngOnInit (): void {

        this.selectedDiscountCodes = this.selectedDiscountCodes ?? [];

        this.selectedDiscounts = [];
        this.discounts.forEach(discount => {

            let selectedItem = {
                discount: discount,
                checked : this.selectedDiscountCodes.findIndex(sd => sd.discountId === discount.discountId) > -1
            }
            this.selectedDiscounts.push(selectedItem);

        });
    }

    public onCheckedDiscountChange(event: any, selectedItem: any) {

        let discountCheckIndex = this.selectedDiscounts.findIndex(dc => selectedItem.discount.discountId === dc.discount.discountId);
        if (discountCheckIndex > -1) {
            this.selectedDiscounts[discountCheckIndex].checked = event.checked;
        }

        this.selectedDiscountCodes = this.selectedDiscounts.filter(sd => sd.checked).flatMap(sd => sd.discount.discountCodes);
        this.selectedDiscountCodesChange.emit(this.selectedDiscountCodes);

    }

}
